module.exports = __webpack_public_path__ + "img/s5.fd839891.png";